// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"25da1de1","466":"362e3503","738":"cd7fa651","856":"f5363ea9"}[chunkId] + ".chunk.js";
};